function desk_init(){





	// Validation and specific form processing

	desk_validate_username();
	desk_validate_email();
	//desk_validate_agreement();
	desk_multistep();
	desk_next_steps();
    desk_maxmind_insights();
    GetURLParameter();
 
}

$(document).ready(function() {
	desk_init();
});

/* ----------------------------
	Multistep validation
---------------------------- */

function desk_multistep() {
	$('#reg_form_next_step').click(function() {

		// Validate username 

		if($('#user-name').val().length < 2) {
			$('#user-name').parent().addClass('has-error');
		} else {
			$('#user-name').parent().removeClass('has-error');
		}

		// Validate email

		if( !desk_regexp_email($('#user-email').val()) ) {
			$('#user-email').parent().addClass('has-error');
		} else {
			$('#user-email').parent().removeClass('has-error');
		}

		// Pass or fail

		if($('.form-group').hasClass('has-error')) {
		} else {
			$('.step-1').hide();
			$('.step-2').show();
		}

	});
}

/* ----------------------------
	Bootstrap tooltips
---------------------------- */

 function desk_tooltips() {
	$('input[data-title]').tooltip({ trigger: 'focus', container: 'body' });
	$('i[data-title]').tooltip({ container: 'body' });
	$('span[data-title]').tooltip({ trigger: 'focus', container: 'body' });
	$('[data-toggle="tooltip"]').tooltip({ trigger: 'focus', container: 'body' });
} 





/* ----------------------------
	Validate user's name
---------------------------- */

function desk_validate_username() {
	$('#user-name').blur(function() {
		if($(this).val().length < 2) {
			$(this).parent().addClass('has-error');
		} else {
			$(this).parent().removeClass('has-error');
		}
	});
}

/* ----------------------------
	Validate email address
---------------------------- */

function desk_regexp_email(emailAddress) {
	var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
	return pattern.test(emailAddress);
}

function desk_validate_email() {
	$('#user-email').blur(function() {
		if( !desk_regexp_email($(this).val()) ) {
			$(this).parent().addClass('has-error');
		} else {
			$(this).parent().removeClass('has-error');
		}
	});
}


/* ----------------------------
	Validate user agreement
---------------------------- */

function desk_validate_agreement() {
	$('#user-agreement').blur(function() {
		if ($(this).is(":checked")) {
			$(this).parent().removeClass('has-error');
			$(this).parent().removeClass('agreement-error');
		} else {
			$(this).parent().addClass('has-error');
			$(this).parent().addClass('agreement-error');
		}
	});
};

/* ----------------------------
	Looks good - Let's goto the next steps
---------------------------- */

function desk_next_steps() {
	$('#form_register button.next').click(function(e) {
		// loop through required for errors
		$(this).parents('fieldset').find('.required').blur();
		// return user to first error
		if( $(this).parents('fieldset').find('.has-error').length > 0 ) {
			$('.has-error input').slice(0,1).focus();
		} else {
			// No errors?  Send to next step
			Bizible.Push('Form',$('#form_register')).always("ReportUserDone", function () {
				$('#form_register').submit();
			}).timeout("ReportUserTimeout", 5200);
		}
		e.preventDefault();
	});
};




/* ----------------------------
	MaxMind Insights
---------------------------- */

function desk_maxmind_insights() {

	var onSuccess = function(location){
		$user_ip = location.traits.ip_address;
		$user_country = location.country.names.en;
		$user_iso_country = location.country.iso_code;

		// Value entering of source fields for Org61 

		$('#form_register').find('#country').val($user_country);
		$('#form_register').find('#ip').val($user_ip );
	};
	
	var onError = function(error){
		console.log('Hmm, not working!');
	};
	
	geoip2.insights(onSuccess, onError);

}




function GetURLParameter(sParam)
{
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
  
  
$email2 = getUrlParameter('e');
$name = getUrlParameter('n');
$('#form_register').find('#email2').val($email2);
$('#form_register').find('#user-email').val($email2);
$('#form_register').find('#user-name').val($name);  
 
  
  
  $("#form_register").submit(function(e) {
    
    var form = $("#form_register");
    var url = "https://track-dot-guextserver.appspot.com/form";
    $.ajax({
           type: "POST",
           url: url,
           data: $("#form_register").serialize(), // serializes the form's elements.
        success: function(result){
           
          window.location.href = "https://foreverspin.com/pages/Confirmation?e="+result["email"]+"&p="+result["phone"]+"&n="+result["name"];
        }
    });
    
    
    e.preventDefault();
    
});
  
}